define('Components/LandingWidget/js/models/SummerBoxWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app'],function(_,Backbone,WidgetInstanceModel,app, sprintf){

    return WidgetInstanceModel.extend({

        name:'LandingWidgetModel',

        getProductsList:function () {

            var model = this,
                id_cat = model.p('catlisting');
            if (!id_cat)
            {
                return [];
            }

            try{
                model.productslist = app.getCategory(id_cat).getProducts().filter(function (p)
                    {
                       var  id_product_tmp = p.id
                       if (id_product_tmp == model.p('product_banner'))
                       {
                           return false;
                       }
                       return true;
                    }
                    )
                }
                catch(e) {
                        return []

                }
                return (model.productslist);
        },
        getProductBanner:function()
        {
            this.product = app.getProduct(this.p('product_banner'));

        },
        getImgSep:function (className)
        {
            
        if (this.p('image_sep') && this.p('image_sep') !=0 )
        {
            return '<img src="'+this.getImage(this.p('image_sep'),'origin') +'" alt="" + class="'+className+'">';
        }

return "";
        },
        getImage: function(id_picture, suffix,format){
            suffix = suffix ? suffix : '1080x1080';
            format = format ? format : 'PNG';


               var url = app.getPictureUrl(id_picture,'Widget',suffix,format,this.getTitle());
            return url || false;
        },
        displayProdutBannerLink:function()
        {
            if (this.product)
            {


                return this.product.getUrl();
            }
        },
        displayProdutId:function()
        {
            if (this.product)
            {


                return this.product.id
            }
        },
        displayProdutBannerPrice:function () {

          if (this.product)
          {
              var price = this.product.getPrice();


              return this.product.formatPriceValue(price);
          }
        },

    })
});
